export default __webpack_public_path__ + "static/media/Sushiswap.3ae31e13.webp";